// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__fa3jn","active":"styles_active__IPo0H"};